module.exports = __webpack_public_path__ + "img/g4.37bebdd0.jpg";